import React from "react";
import Icon from "@amzn/awsui-components-react/polaris/icon";
import HoverTooltip from "../ellipsisText/HoverTooltip";
import "./ColumnHeader.css";

/**
 * A column title with an info icon beside it; hovering or focusing the icon shows what the column means.
 * `info` is a sentence, or an element for richer content (then `infoLabel` names it and the tooltip can be scrolled).
 */
export default function ColumnHeader({title, info, infoLabel}) {
    if (!info) {
        return title;
    }
    const rich = typeof info !== "string";
    return (
        <span className="columnHeader">
            {title}
            <HoverTooltip text={info} label={rich ? (infoLabel ?? `About ${title}`) : undefined} interactive={rich}>
                <span className="columnHeaderInfo" role="button" tabIndex={0}
                      onClick={event => event.stopPropagation()}
                      onKeyDown={event => {
                          if (event.key === "Enter" || event.key === " ") {
                              event.preventDefault();
                              event.stopPropagation();
                          } else if (event.key === "Escape") {
                              event.currentTarget.blur();
                          }
                      }}>
                    <Icon name="status-info" variant="subtle" />
                </span>
            </HoverTooltip>
        </span>
    );
}
